"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.filter");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTransformProductParamsToGroups;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _useProductPatameterGroups = _interopRequireDefault(require("../useProductPatameterGroups"));

var _useConsolidatedParams = _interopRequireDefault(require("../useConsolidatedParams"));

var _transformProductParamsToGroups = _interopRequireDefault(require("./transformProductParamsToGroups"));

/**
 * @param {Object} options
 * @param {string} [options.groupsFilter]
 * @param {string} [options.parametersField = 'parameters']
 * @param {string} [options.parametersFilter]
 * @param {string} options.translationPrefix
 * @param {Object} product
 *
 * @returns Memoized merged and normalized `Array` of product parameters.
 */
function useTransformProductParamsToGroups(options, product) {
  var groupsFilter = options.groupsFilter,
      parametersFilter = options.parametersFilter,
      restOptions = (0, _objectWithoutProperties2.default)(options, ["groupsFilter", "parametersFilter"]);
  var t = (0, _useTranslate.default)();

  var _useProductPatameterG = (0, _useProductPatameterGroups.default)(),
      _useProductPatameterG2 = (0, _slicedToArray2.default)(_useProductPatameterG, 1),
      groups = _useProductPatameterG2[0];

  var consolidatedParamsSrc = (0, _useConsolidatedParams.default)(restOptions, product);

  var consolidatedParams = _react.default.useMemo(function () {
    return parametersFilter ? consolidatedParamsSrc.filter(parametersFilter) : consolidatedParamsSrc;
  }, [consolidatedParamsSrc, parametersFilter]);

  return _react.default.useMemo(function () {
    return (0, _transformProductParamsToGroups.default)(groups, groupsFilter, t, consolidatedParams);
  }, [consolidatedParams, groups, groupsFilter, t]);
}